import { getIsAudioOnlyPipeSnapshotUrl } from "./pipe.js";
// sort order to use if you want to put a reaction at the end of the list
export const REACTION_SORT_ORDER_END = 999999;
export function sortReactions(reactions) {
    const reactionIdToProcessingStatus = {};
    function getReactionProcessingStatusProxy(reaction) {
        if (reactionIdToProcessingStatus[reaction.reactionId]) {
            return reactionIdToProcessingStatus[reaction.reactionId];
        }
        const processingStatus = getReactionProcessingStatus(reaction);
        reactionIdToProcessingStatus[reaction.reactionId] = processingStatus;
        return processingStatus;
    }
    return reactions.sort((a, b) => {
        const aProcessingStatus = getReactionProcessingStatusProxy(a);
        const bProcessingStatus = getReactionProcessingStatusProxy(b);
        const aInvalid = aProcessingStatus === "invalid";
        const bInvalid = bProcessingStatus === "invalid";
        // always put invalid segments last
        if (aInvalid && !bInvalid) {
            // A should come after B
            return 1;
        }
        else if (!aInvalid && bInvalid) {
            // A should come before B
            return -1;
        }
        // always put discarded reactions second to last
        else if (a.publishStatus === "discarded" &&
            b.publishStatus !== "discarded") {
            // A should come after B
            return 1;
        }
        else if (a.publishStatus !== "discarded" &&
            b.publishStatus === "discarded") {
            // A should come before B
            return -1;
        }
        // if sortOrder is the same, sort by createdAt
        else if (a.sortOrder === b.sortOrder) {
            return a.createdAt - b.createdAt;
        }
        else {
            return a.sortOrder - b.sortOrder;
        }
    });
}
/**
 * Ensures that reaction sortOrders will be in continuous order (starting at 0).
 * Should only be called on *all* reactions for a card.
 *
 * NOTE: Will update the sortOrder in-place.
 */
export async function ensureReactionContinuousSortOrderGeneral(
// should already be sorted
sortedReactions, 
// sortOrder will be updated in this reaction object
onUpdate) {
    // start at -1 so that when we increment, the first sortOrder will be 0
    let expectedSortOrder = -1;
    for (const reaction of sortedReactions) {
        expectedSortOrder++;
        if (reaction.sortOrder !== expectedSortOrder) {
            reaction.sortOrder = expectedSortOrder;
            await onUpdate(reaction);
        }
    }
    return sortedReactions;
}
export function getReactionProcessingStatus(reaction) {
    if (reaction.processingStatus === "invalid") {
        return "invalid";
    }
    else if (reaction.processingStatus === "processing") {
        return "processing";
    }
    else if (reaction.processingStatus === "complete") {
        return "complete";
    }
    else if (!reaction.videoUrl.s3) {
        return "processing";
    }
    else if (getIsAudioOnlyPipeSnapshotUrl(reaction.thumbUrl.s3) ||
        reaction.durationInSeconds <= 0) {
        return "invalid";
    }
    else {
        return "complete";
    }
}
